import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import { useHistory } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert"; // Import

// mrx : components
import {
  Header_panel2,
} from "../Useful/Useful";
import { Button } from "reactstrap";

// mrx : styles
import "./user.css";
import "react-toastify/dist/ReactToastify.css";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

// mrx : api 
import {
  GetAllUserList,
  EditUserByIDALL,
  SearchAllUser,
  USerGetById,
  ADDUserByIDALL,
  DELETE_BY_ID_IN_All_USer,
} from "../../fetch";

// mrx : icons
import {
  FcFullTrash,
  FcEditImage,
} from "react-icons/fc";

export default function User_list(props) {
  // mrx : states
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rowslength, setrowslength] = useState(0);
  const [ShowList, setShowList] = useState(true);
  const [IsEditing, setIsEditing] = useState(false);
  const [SearchText, setSearchText] = useState('');
  const [UsingID, setUsingID] = useState("");
  const [IsAdding, setIsAdding] = useState(false);
  const [LeadStatus, setLeadStatus] = useState('');

  // mrx : forms value
  const [FullName, setFullName] = useState('');
  const [UserName, setUserName] = useState('');
  const [PhoneNumber1, setPhoneNumber1] = useState('');
  const [PhoneNumber2, setPhoneNumber2] = useState('');
  const [Passeord, setPasseord] = useState('');
  const [RePasseord, setRePasseord] = useState('');


  // mrx : functions ( start )

  // mrx : get all users
  useEffect(() => {
    GetAllUsersEffect();
  }, [page, rowsPerPage]);

  const GetAllUsersEffect = () => {
    setLeadStatus('لیست کاربران');
    setLoading(true);
    GetAllUserList(0, rowsPerPage)
      .then((response) => {
        setLoading(false);

        return response.json();
      })
      .then((responseJson) => {
        setRows(responseJson.result);
        setrowslength(responseJson.count);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  // mrx : Search By Phone Number in all users
  const handleSearchAllUSer = () => {
    setLoading(true);
    if (SearchText.length < 1) {
      toast.warning("شماره مورد نظر را برای جستجو وارد کنید ");
      setLoading(false);
    } else {
      SearchAllUser(SearchText)
        .then((response) => {
          setLoading(false);
          return response.json();
        })
        .then((responseJson) => {
          setRows(responseJson.result);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    }
  }

  // mrx : Add User
  const handleAddUser = () => {
    setLoading(true);
    if (Passeord.length > 1 && Passeord !== RePasseord) {
      toast.warning("رمز عبور جدید بایکدیگر همخوانی ندارند")
      setLoading(false);
    } else if (UserName === '') {
      toast.warning("نام کاربری مورد نظر را وارد کنید ")
      setLoading(false);
    } else if (FullName === '') {
      toast.warning("نام و نام خانوادگی خود را وارد کنید  ")
      setLoading(false);
    } else if (Passeord !== '' && Passeord.length < 6) {
      toast.warning("رمز عبور باید بیشتر از 6 کاراکتر باشد")
      setLoading(false);
    } else if (Passeord === '') {
      toast.warning("وارد کردن رمز عبور برای ثبت کاربر ضروری میباشد ")
      setLoading(false);
    } else {
      ADDUserByIDALL({
        Fullname: FullName,
        Mobile1: PhoneNumber1,
        Mobile2: PhoneNumber2,
        Password: Passeord,
        UserName: UserName
      })
        .then((response) => {
          setLoading(false);
          return response.json();
        })
        .then((responseJson) => {
          GetAllUsersEffect();
          setLoading(false);
          setLeadStatus('لیست کاربران')
          handleCloseEditing();
          toast.success("کاربر با موفقیت اضافه شد");
          // setRows(responseJson.result);
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    }
  }


  // mrx : Edit User By ID
  const handleEditUser = () => {
    setLoading(true);
    if (Passeord.length > 1 && Passeord !== RePasseord) {
      toast.warning("رمز عبور جدید بایکدیگر همخوانی ندارند")
      setLoading(false);
    } else if (Passeord !== '' && Passeord.length < 6) {
      toast.warning("رمز عبور باید بیشتر از 6 کاراکتر باشد")
      setLoading(false);
    } else {
      EditUserByIDALL({
        Id: UsingID,
        Fullname: FullName,
        Mobile1: PhoneNumber1,
        Mobile2: PhoneNumber2,
        Password: Passeord,
        UserName: UserName
      })
        .then((response) => {
          setLoading(false);
          return response.json();
        })
        .then((responseJson) => {
          // setRows(responseJson.result);
          GetAllUsersEffect();
          setLoading(false);
          setLeadStatus('لیست کاربران')
          handleCloseEditing();
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    }
  }

  // mrx : Get User vlaue by id for editing ( getting data )
  const HandleGetEditValue = (id) => {
    setLeadStatus('ویرایش کاربر');
    setUsingID(id);
    setLoading(true);
    USerGetById(id)
      .then((response) => {
        setLoading(false);
        return response.json();
      })
      .then((responseJson) => {
        setUserName(responseJson.userName);
        setFullName(responseJson.fullname);
        setPhoneNumber1(responseJson.mobile1);
        setPhoneNumber2(responseJson.mobile2);
        setLeadStatus('ویرایش کاربر');
        setIsEditing(true);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  }

  // mrx : closing edit tab and reset Values
  const handleCloseEditing = () => {
    setIsEditing(false);
    setUserName("");
    setLeadStatus('لیست کاربران');
    setFullName("");
    setPhoneNumber1("");
    setPhoneNumber2("");
    setPasseord("");
    setRePasseord("");
  }

  // mrx : Delete User By ID
  const hendleDelet = (deleteId) => {
    confirmAlert({
      title: " حذف کردن ",
      message: "آیا میخواهید این کاربر راحذف کنید؟",
      buttons: [
        {
          label: "تایید",
          onClick: () => {
            setLoading(true);
            DELETE_BY_ID_IN_All_USer(deleteId)
              .then((response) => {
                setLoading(false);
                if (response.status === 200) {
                  console.log("succcess");
                  toast.success("کاربر با موفقیت حذف  شد");
                }
                return response.json();
              })
              .then((responseJson) => {
                setLoading(false);
                setRows(rows.filter((row) => row.id !== deleteId));
              })
              .catch((error) => {
                setLoading(false);
                console.log(error);
              });
          },
        },
        {
          label: "لغو",
        },
      ],
    });
  };

  useEffect(() => {
    if (SearchText === '') {
      GetAllUsersEffect()
    }
  }, [SearchText]);


  return (
    <div>
      <div class="col-12 mypanel shadow">

        <Header_panel2
          ShowList={ShowList}
          setShowList={setShowList}
          title={LeadStatus}
          idMenu="#navbarToggleExternalContentUserList"
        />

        <div className="d-flex justify-content-center">
          {loading && (
            <>
              <Spinner animation="grow" variant="info" size="lg" />
              <div> صفحه در حال بارگزاری است ...</div>
            </>
          )}
        </div>

        {/* User List ( Start ) */}
        <div class="pos-f-t">
          {
            ShowList && IsEditing === false ? (
              <div>
                <br />

                {/* Search And Add Button here  ( start ) */}
                <div className="row">
                  <div className="col-lg-6">
                    <div class="input-group-prepend">
                      <input
                        name="usermobile"
                        value={SearchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        type="search"
                        class="form-control"
                        placeholder="شماره تماس مورد نظر را وارد کنید ..."
                        aria-label=""
                        aria-describedby="basic-addon1"
                      />
                      <button
                        class="btn btn-outline-secondary"
                        type="button"
                        style={{ marginRight: "10px" }}
                        onClick={() => handleSearchAllUSer()}
                      >
                        جستجو
                      </button>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div class="input-group-prepend">
                      {
                        !loading && (
                          <button
                            style={{
                              position: "absolute",
                              left: "60px"
                            }}
                            class="btn btn-outline-secondary"
                            type="button"
                            onClick={() => { setIsEditing(true); setLeadStatus('ساخت کاربر جدید') }}
                          >
                            افزودن کاربر جدید
                          </button>
                        )
                      }
                    </div>
                  </div>
                </div>
                {/* Search And Add Button here  ( end ) */}

                <div class="p-4 mytable">
                  <table class="table table-striped rtltable">
                    <thead>
                      <tr>
                        <th>شماره</th>
                        <th>نام</th>
                        <th>شماره تماس 1</th>
                        <th>شماره تماس 2</th>
                        <th>ویرایش</th>
                        <th>حذف کاربر</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows
                        .map((row, index) => {
                          return (
                            <tr>
                              <td>{page * rowsPerPage + index + 1}</td>
                              <td>{row?.fullname ? row?.fullname : "---"}</td>
                              <td>{row?.mobile1 ? row?.mobile1 : "---"}</td>
                              <td>{row?.mobile2 ? row?.mobile2 : "---"}</td>
                              <td>
                                <Button
                                  onClick={() => HandleGetEditValue(row?.id)}
                                  style={{
                                    background: "transparent",
                                    border: "none",
                                    fontSize: "25px"
                                  }}
                                ><FcEditImage />
                                </Button>
                              </td>
                              <td>
                                <Button
                                  onClick={() => hendleDelet(row?.id)}
                                  style={{
                                    background: "transparent",
                                    border: "none",
                                    fontSize: "25px"
                                  }}
                                ><FcFullTrash />
                                </Button>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <></>
            )
          }
          {/* User List ( end ) */}

          {/* if want to edit user change screen to edit Screen ( start ) */}
          {
            IsEditing && (
              <>
                <div style={{ paddingTop: "20px" }} className="container col-lg-12 row">
                  <div className="col-lg-4">
                    <div className="form-group textg">
                      <label className="control-label" htmlFor="name">
                        نام و نام خانوادگی
                      </label>
                      <input
                        value={FullName}
                        onChange={(e) => setFullName(e.target.value)}
                        required
                        id="Name"
                        className="contactInput form-control"
                        name="Name"
                        placeholder="نام و نام خانوادگی را وارد کنید"
                      />
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="form-group textg">
                      <label className="control-label" htmlFor="name">
                        نام کاربری
                      </label>
                      <input
                        required
                        value={UserName}
                        onChange={(e) => setUserName(e.target.value)}
                        id="UserName"
                        className="contactInput form-control"
                        name="UserName"
                        placeholder="نام کاربری را وارد کنید"
                      />
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="form-group textg">
                      <label className="control-label" htmlFor="name">
                        شماره تماس 1
                      </label>
                      <input
                        equired
                        value={PhoneNumber1}
                        onChange={(e) => setPhoneNumber1(e.target.value)}
                        id="PhoneNumber1"
                        className="contactInput form-control"
                        name="PhoneNumber1"
                        placeholder="شماره تماس را وارد کنید"
                      />
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="form-group textg">
                      <label className="control-label" htmlFor="name">
                        شماره تماس 2
                      </label>
                      <input
                        value={PhoneNumber2}
                        onChange={(e) => setPhoneNumber2(e.target.value)}
                        required
                        id="PhoneNumber2"
                        className="contactInput form-control"
                        name="PhoneNumber2"
                        placeholder="شماره تماس را وارد کنید"
                      />
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="form-group textg">
                      <label className="control-label" htmlFor="name">
                        رمز عبور
                      </label>
                      <input
                        value={Passeord}
                        onChange={(e) => setPasseord(e.target.value)}
                        required
                        id="Password"
                        className="contactInput form-control"
                        name="Password"
                        placeholder="رمز عبور جدید خود را وارد کنید"
                      />
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="form-group textg">
                      <label className="control-label" htmlFor="name">
                        تکرار رمز عبور
                      </label>
                      <input
                        value={RePasseord}
                        onChange={(e) => setRePasseord(e.target.value)}
                        required
                        id="RePassword"
                        className="contactInput form-control"
                        name="RePassword"
                        placeholder="تکرار رمز عبور جدید"
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 row" style={{ display: "table-column", marginTop: "50px" }}>
                    <Button onClick={() => handleCloseEditing()} >
                      بستن
                    </Button>

                    <Button onClick={() => LeadStatus !== 'ساخت کاربر جدید' ? handleEditUser() : LeadStatus === 'ساخت کاربر جدید' && handleAddUser()} style={{ background: "#4663ff", marginRight: "20px", with: "200px", marginLeft: "-15px" }}>
                      {
                        LeadStatus !== 'ساخت کاربر جدید' ?

                          " ویرایش"
                          : LeadStatus === 'ساخت کاربر جدید' &&
                          "افزودن"
                      }

                    </Button>

                  </div>
                </div>
              </>
            )
          }
          {/* if want to edit user change screen to edit Screen ( end ) */}

        </div>
      </div>
    </div >
  );
}
